import { createAnswerSchemaWithMixins } from '../answerSchemaFields';
import {
  createQuestionSchemaWithMixins,
  questionHasComment,
  questionHasTimer,
  questionImage,
  questionInstantStatistic,
  questionRequiresAnswer,
} from '../questionSchemaFields';
import { config } from './SelectAreaPoll.config';

export const schema = createQuestionSchemaWithMixins({
  mixins: {
    questionHasComment,
    questionHasTimer,
    questionImage,
    questionRequiresAnswer,
    questionInstantStatistic,
  },
  type: config.name,
  answer: createAnswerSchemaWithMixins({
    base: {
      type: 'object',
      properties: {
        figure: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              path: { type: 'string' },
              start: { type: 'string' },
            },
            required: ['start', 'path'],
          },
        },
      },
      required: ['figure'],
    },
  }),
});
